import Box from '@mui/material/Box'

export type HighlightedTextProps = {
	text: string,
	search: string,
};

/**
 * MUI-branch stand-in for `EuiHighlight`: bolds the first case-insensitive
 * occurrence of the search string, matching EUI's default `highlightAll={false}`.
 */
export default function HighlightedText( { text, search }: HighlightedTextProps ) {
	const matchIndex = search ? text.toLowerCase().indexOf( search.toLowerCase() ) : -1
	const matchEnd = matchIndex + search.length

	// EuiHighlight also renders a plain span wrapper.
	return (
		<Box component="span">
			{matchIndex === -1 ? text : (
				<>
					{text.slice( 0, matchIndex )}
					<Box component="strong">{text.slice( matchIndex, matchEnd )}</Box>
					{text.slice( matchEnd )}
				</>
			)}
		</Box>
	)
}
